<template>
    <div id="data-entidad-view">
        <vx-card class="mb-base" no-shadow card-border>
            <div class="flex items-end mb-2">
                <feather-icon icon="HomeIcon" class="mr-2" svgClasses="w-5 h-5" />
                <span class="font-medium leading-none">Unidades Ejecutora</span>
            </div>

            <vs-divider/>

            <div class="justify-between flex-grow vx-row">
                <div class="w-full mb-2 vx-col md:w-1/5">                   
                    <div class="mb-2">
                        <label class="text-sm opacity-75">Estado</label>
                        <v-select :options="itemsEstado" v-model="selectedEstado" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" name="estado">
                            <template v-slot:no-options="{ searching }">
                                <template v-if="searching">
                                    No se encontraron resultados
                                </template>
                                <span v-else style="opacity: 0.5">No existen resultados</span>
                            </template>
                        </v-select>
                        <span class="text-sm text-danger" v-show="errors.has('estado')">{{ errors.first('estado') }}</span>
                    </div>
                </div>

                <div class="flex flex-wrap-reverse items-center justify-end flex-grow">
                    <div class="flex flex-wrap items-center justify-start">
                        <vs-button @click="agregar" icon-pack="feather" color="primary" icon="icon-plus" class="ml-auto vs-con-loading__container" id="button-sincr-with-loading">Nuevo</vs-button>
                    </div>
                </div>

            </div>
            
            <vs-table stripe ref="table" :data="itemsUnidadEjecutora" pagination :max-items="itemsPerPage" search noDataText="No existen datos" id="div-ejecutora-with-loading">
                <div slot="header" class="flex flex-wrap-reverse items-center justify-between flex-grow">
                    <vs-dropdown vs-trigger-click class="mb-4 mr-4 cursor-pointer items-per-page-handler">
                        <div class="flex items-center justify-between p-4 font-medium border border-solid rounded-full cursor-pointer d-theme-border-grey-light d-theme-dark-bg">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ itemsUnidadEjecutora.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : itemsUnidadEjecutora.length }} de {{ itemsUnidadEjecutora.length }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="itemsPerPage=5">
                            <span>5</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=25">
                            <span>25</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th class="">CODIGO</vs-th>
                    <vs-th class="">UNIDAD EJECUTORA</vs-th>
                    <vs-th class="">RUC</vs-th>
                    <vs-th class="">NIVEL DE GOBIERNO</vs-th>
                    <vs-th class="">ESTADO</vs-th>
                    <vs-th class="">ACCIONES</vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].id">
                                <strong>
                                    <span class="text-primary text-bold">{{data[indextr].id}}</span>
                                </strong>
                            </vs-td>
                            <vs-td :data="data[indextr].id">
                                <strong>
                                    <span class="text-bold">{{ data[indextr].nombre }}</span>
                                </strong>
                            </vs-td>
                            <vs-td :data="data[indextr].id">
                                {{ data[indextr].ruc }}
                            </vs-td>
                            <vs-td :data="data[indextr].id">
                                {{ data[indextr].nivel.descripcion }}
                            </vs-td>
                            <vs-td :data="data[indextr].id">
                                <vs-chip transparent :color="statusColor(data[indextr].enabled)">
                                    <span class="font-medium truncate"> {{ data[indextr].enabled ? 'Habilitado' : 'Inhabilitado' }}</span>
                                </vs-chip>
                            </vs-td>
                            <vs-td :data="data[indextr].id" class="whitespace-no-wrap">
                                <div class="vx-row-actions">
                                    <vx-tooltip v-if="!data[indextr].enabled" text="Habilitar" position="bottom">
                                        <vs-button v-if="!data[indextr].enabled" @click="enabled(tr)" class="ml-2" color="success" type="filled" icon-pack="feather" icon="icon-thumbs-up" size="small"></vs-button>
                                    </vx-tooltip>
                                    <vx-tooltip v-if="data[indextr].enabled" text="Inhabilitar" position="bottom">
                                        <vs-button v-if="data[indextr].enabled" @click="disabled(tr)" class="ml-2" color="danger" type="filled" icon-pack="feather" icon="icon-thumbs-down" size="small"></vs-button>
                                    </vx-tooltip>
                                    <vx-tooltip text="Editar ejecutora" position="bottom">
                                        <vs-button @click="edit(tr)" class="ml-2" color="rgb(62, 201, 214)" type="filled" icon-pack="feather" icon="icon-edit" size="small"></vs-button>
                                    </vx-tooltip>
                                    <vx-tooltip text="Eliminar ejecutora" position="bottom">
                                        <vs-button @click="eliminar(tr)" class="ml-2" color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small"></vs-button>
                                    </vx-tooltip>
                                </div>
                            </vs-td>
                        </vs-tr>
                    </tbody>
                </template>

            </vs-table>
            
            <div class="flex flex-wrap-reverse items-center justify-end flex-grow">
                <p class="text-sm truncate">
                    Mostrando registros del <strong>{{ currentPage * itemsPerPage - (itemsPerPage - 1) }}</strong> al <strong>{{ itemsUnidadEjecutora.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : itemsUnidadEjecutora.length }}</strong> de un total de <strong>{{ itemsUnidadEjecutora.length }}</strong> registros
                </p>
            </div>

        </vx-card>
    </div>
</template>
<script>
import vSelect from 'vue-select';
export default {
    components: {
        'v-select': vSelect
    },
    data(){
        return {
            itemsUnidadEjecutora: [],
            itemsPerPage: 10,
            isMounted: false,

            unidadEjecutoraId: null,
            selectedEstado: {value: 0, label: 'Todo'},
            itemsEstado: [{value: 0, label: 'Todo'}, {value: 1, label: 'Habilitado'}, {value: 2, label: 'Inhabilitado'}],

            backgroundLoading: 'primary',
            colorLoading: '#fff',
        }
    },

    computed: {
        currentPage () {
            if (this.isMounted) {
                return this.$refs.table.currentx;
            }
            return 0;
        },
    },

    mounted(){
        this.isMounted = true;
        this.listarEjecutoras();
    },

    watch: {
        selectedEstado(seleted){
            if(seleted.value === 0){
                this.listarEjecutoras();
            } else if(seleted.value == 1){
                this.listarEjecutorasHabilitadas();
            } else {
                this.listarEjecutorasInhabilitadas();
            }
        },
    },

    methods: {
        agregar(){
            this.$vs.dialog({
                color: 'primary',
                title: `Información`,
                text: 'En desarrollo...',
                acceptText: 'Aceptar'
            });
        },

        edit(tr){
            this.$vs.dialog({
                color: 'primary',
                title: `Información`,
                text: `Componente actualizacion en desarrollo... ${tr.nombre}`,
                acceptText: 'Aceptar'
            });
        },  

        listarEjecutoras(){
            this.$vs.loading({
                container: '#div-ejecutora-with-loading',
                scale: 0.7
            });
            this.$http.listarUnidadEjecutora()
            .then((response) => {
                this.$vs.loading.close('#div-ejecutora-with-loading > .con-vs-loading');
                this.itemsUnidadEjecutora = response.data;
            })
            .catch((error) => {
                this.$vs.loading.close('#div-ejecutora-with-loading > .con-vs-loading');
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarEjecutorasHabilitadas(){
            this.$vs.loading({
                container: '#div-ejecutora-with-loading',
                scale: 0.7
            });
            this.$http.listarUnidadEjecutoraHabilitados()
            .then((response) => {
                this.$vs.loading.close('#div-ejecutora-with-loading > .con-vs-loading');
                this.itemsUnidadEjecutora = response.data;
            })
            .catch((error) => {
                this.$vs.loading.close('#div-ejecutora-with-loading > .con-vs-loading');
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        listarEjecutorasInhabilitadas(){
            this.$vs.loading({
                container: '#div-ejecutora-with-loading',
                scale: 0.7
            });
            this.$http.listarUnidadEjecutoraInhabilitados()
            .then((response) => {
                this.$vs.loading.close('#div-ejecutora-with-loading > .con-vs-loading');
                this.itemsUnidadEjecutora = response.data;
            })
            .catch((error) => {
                this.$vs.loading.close('#div-ejecutora-with-loading > .con-vs-loading');
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        enabled(tr){
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirmación`,
                text: '¿Esta seguro de habilitar la ejecutora ' + tr.nombre + '?',
                acceptText: 'Si',
                cancelText: 'No',
                accept: this.habilitarUnidadEjecutora,
            });
            this.unidadEjecutoraId = tr.id;
        },

        disabled(tr){
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirmación`,
                text: '¿Esta seguro de inhabilitar la ejecutora ' + tr.nombre + '?',
                acceptText: 'Si',
                cancelText: 'No',
                accept: this.inhabilitarUnidadEjecutora.bind(this, tr),
            });
            this.unidadEjecutoraId = tr.id;
        },

        eliminar(tr){
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Confirmación`,
                text: '¿Esta seguro de eliminar la ejecutora ' + tr.nombre + '?',
                acceptText: 'Si',
                cancelText: 'No',
                accept: this.eliminarUnidadEjecutora.bind(this, tr),
            });
            this.unidadEjecutoraId = tr.id;
        },

        habilitarUnidadEjecutora(){
            this.$vs.loading();
            this.$http.habilitarUnidadEjecutora(this.unidadEjecutoraId)
            .then(response => {
                console.log(response);
                this.$vs.loading.close();
                this.showMessageSuccess('Se habilitó de forma correcta.');
                this.listarEjecutoras();
                this.unidadEjecutoraId = null;
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        inhabilitarUnidadEjecutora(){
            this.$vs.loading();
            this.$http.inhabilitarUnidadEjecutora(this.unidadEjecutoraId)
            .then(response => {
                console.log(response);
                this.$vs.loading.close();
                this.showMessageSuccess('Se inhabilitó de forma correcta.');
                this.listarEjecutoras();
                this.unidadEjecutoraId = null;
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        eliminarUnidadEjecutora(){
            this.$vs.loading();
            this.$http.eliminarUnidadEjecutora(this.unidadEjecutoraId)
            .then(response => {
                console.log(response);
                this.$vs.loading.close();
                this.showMessageSuccess('Se eliminó de forma correcta.');
                this.listarEjecutoras();
                this.unidadEjecutoraId = null;
            })
            .catch(error => {
                this.$vs.loading.close();
                this.showMessageError(error.response.status, error.response.data.message);
            });
        },

        statusColor (status) {
            if (status) return 'success'
            return 'danger'
        },

        showMessageAlert(message){
            this.$vs.notify({
                title: 'Aviso',
                text: message,
                position:'top-center',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        },

        showMessageSuccess(message){
            this.$vs.notify({
                title: 'Información',
                text: message,
                position:'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
            });
        },

        showMessageError(status, message){
            if(status === 400 || status === 409){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 401){
                this.popupRiesgo = false;
                this.$store.dispatch("logout").then(() => {
                    this.$router.push('/login').catch(() => {})
                });
            }
            if(status === 403){
                this.popupPaciente = false;
                this.popupEliminar = false;
                this.$vs.notify({
                    title: 'ACCESO DENEGADO',
                    text: 'No tiene permisos para esta proceso.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            if(status === 404){
                this.$vs.notify({
                    title: 'Aviso',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });
            }
            if(status === 417){
                this.$vs.notify({
                    title: 'ALERTA',
                    text: message,
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }

            if(status === 500){
                this.$vs.notify({
                    title: 'ERROR',
                    text: 'Ups!!!. Ocurrio un error. Vuelve a intentarlo.',
                    position:'top-center',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle',
                    color: 'danger'
                });
            }
        },
    },
}
</script>
<style lang="scss">
#data-entidad-view {
.vs-con-table {
    @media (max-width: 689px) {
        .vs-table--search {
            margin-left: 0;
            max-width: unset;
            width: 100%;

            .vs-table--search-input {
                width: 100%;
            }
        }
    }

    @media (max-width: 461px) {
        .items-per-page-handler {
            display: none;
        }
    }

    @media (max-width: 341px) {
        .data-list-btn-container {
            width: 100%;

            .dd-actions,
            .btn-add-new {
                width: 100%;
                margin-right: 0 !important;
            }
        }
    }

    .vs-table--header {
        display: flex;
        flex-wrap: wrap;
        margin-left: 0.0rem;
        margin-right: 0.0rem;
        > span {
            display: flex;
            flex-grow: 1;
        }

        .vs-table--search{
            padding-top: 0;

            .vs-table--search-input {
                padding: 1.0rem 2.5rem;
                font-size: 1rem;

                &+i {
                    left: 1rem;
                }

                &:focus+i {
                    left: 1rem;
                }
            }
        }
    }

    .vs-table {
        font-size: 0.88rem;
        font-weight: 400;
        tr {
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
            td {
                padding: 10;
            }
            td.td-check {
               padding: 20px !important;
            }
        }
    }

    .vs-table--thead{
        th {
            padding: 10;
            background: #d9d8d8;
      
            &:first-child{
                border-top-left-radius: .3rem;
                border-bottom-left-radius: .3rem;
            }
            &:last-child{
                border-top-right-radius: .3rem;
                border-bottom-right-radius: .3rem;
            }
            .vs-table-text{
                text-transform: uppercase;
                font-weight: 600;
            }
        }
        th.td-check{
            padding: 0 15px !important;
        }
        tr{
            background: none;
            box-shadow: none;
        }
    }

    .vs-table--pagination {
        justify-content: center;
    }
  }
}

.vx-row-actions {
  display: flex;
  flex-wrap: nowrap;
  margin: 0 -1rem;

  & > .vx-col {
    padding: 0 1rem;
  }

  &.match-height>.vx-col {
    display: flex;
  }

  &.no-gutter {
    margin: 0;

    & > .vx-col {
      padding: 0;
    }
  }
}
</style>